import BasePolicy from '@/policies/BasePolicy.js';

// The server's destroy refuses in-progress assignments with a 400, so Remove is not offered for them.
const NOT_REMOVABLE = ['completed', 'in_progress', 'removed'];

/**
 * Mirrors App\Policies\AutomatedSurveyAssignmentPolicy for the Evaluation Assignments
 * dashboard: only is_admin users (Owner, Admin, Instruction Admin) may act, as
 * InstructionAdminPolicyCheck::before() decides on the server. No permission grants it.
 *
 * Unlike BasePolicy, admins do not bypass the row checks: a completed assignment is not
 * offered for removal (matching SurveyDeploymentPeople), an in-progress one is not either
 * (AutomatedSurveyAssignmentController::destroy refuses it; End it instead), and only a
 * removed one can be restored. The server still allows removing a completed assignment
 * through other callers.
 */
export default class AutomatedSurveyAssignmentPolicy extends BasePolicy {
    before() {
        return undefined;
    }

    viewDashboard(user) {
        return !!user.is_admin;
    }

    delete(user, assignment) {
        return !!user.is_admin && !NOT_REMOVABLE.includes(assignment?.status);
    }

    restore(user, assignment) {
        return !!user.is_admin && assignment?.status === 'removed';
    }

    // Only an in-progress evaluation can be ended; the server re-checks it under the row lock.
    end(user, assignment) {
        return !!user.is_admin && assignment?.status === 'in_progress';
    }

    // Only a completed assignment (including one completed when its time ran out) can be reset.
    reset(user, assignment) {
        return !!user.is_admin && assignment?.status === 'completed';
    }
}
